import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Navigation } from 'lucide-react';

export const ContactMap = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  // VTV Enterprises Location
  const googleMapsUrl = 'https://maps.app.goo.gl/b6RyTeKd6GHfuU3A6';

  return (
    <section ref={ref} className="py-10 sm:py-14 bg-muted/30">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl sm:text-4xl font-bold mb-4">
            Find Us on <span className="gradient-text-blue">the Map</span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Visit our location
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={isInView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.95 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="max-w-5xl mx-auto"
        >
          <div className="glass-card p-4 sm:p-6 rounded-2xl">
            <div className="aspect-video rounded-xl overflow-hidden bg-secondary/20 border border-border relative">
              {/* Map Placeholder with actual iframe */}
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3931.5906344663804!2d80.195506811142!3d9.8006624402494!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3aff03004e35d9d3%3A0x151c62ac30784c7a!2sVTV%20Enterprises%20(PVT)%20LTD!5e0!3m2!1sen!2slk!4v1767417170370!5m2!1sen!2slk"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="VTV Enterprises Location"
                className="absolute inset-0"
              />
            </div>

            <div className="mt-6 flex justify-center">
              <a
                href={googleMapsUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors font-medium"
              >
                <Navigation className="h-5 w-5" />
                Get Directions
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
